
import { Helmet } from 'react-helmet-async';
import { useRealtimeSettings } from '@/hooks/useRealtimeSettings';
import { ADRESSE_ENTREPRISE, PROFILS_ENTREPRISE } from '@/constants/entreprise';

export const StructuredData = () => {
  const { settings } = useRealtimeSettings();

  const websiteStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Maison Eridia",
    "alternateName": ["Eridia", "Maison Eridia Évènements"],
    "url": "https://maisoneridia.fr",
    "description": "Agence évènementielle de luxe à Paris. Direction artistique, scénographie sur-mesure et privatisation exclusive pour mariages prestige, séminaires haut de gamme et soirées d'entreprise en Île-de-France.",
    "publisher": {
      "@type": "Organization",
      "name": "Maison Eridia",
      "logo": {
        "@type": "ImageObject",
        "url": settings?.logoUrl || "/lovable-uploads/maison-eridia-logo.png"
      }
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://maisoneridia.fr/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  const organizationStructuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Maison Eridia",
    "alternateName": ["Eridia", "Maison Eridia Évènements"],
    "url": "https://maisoneridia.fr",
    "logo": settings?.logoUrl || "/lovable-uploads/maison-eridia-logo.png",
    "image": settings?.logoUrl || "/lovable-uploads/maison-eridia-logo.png",
    "description": "Maison Eridia est une agence évènementielle de luxe à Paris, spécialisée dans la direction artistique et la scénographie d'évènements prestige. Wedding planner luxe Paris, organisation de séminaires prestige, soirées d'entreprise haut de gamme : privatisation exclusive et confidentialité absolue en Île-de-France.",
    "telephone": settings?.phone || "+33 7 49 40 34 60",
    "email": settings?.email || "hello@maisoneridia.com",
    "areaServed": [
      {
        "@type": "State",
        "name": "Île-de-France"
      },
      {
        "@type": "City",
        "name": "Paris"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Hauts-de-Seine"
      },
      {
        "@type": "AdministrativeArea", 
        "name": "Val-de-Marne"
      }
    ],
    "address": ADRESSE_ENTREPRISE,
    "priceRange": "€€€",
    "serviceType": [
      "Wedding Planning Luxe Paris",
      "Direction Artistique Évènementielle",
      "Scénographie Mariage Prestige",
      "Organisation Séminaire Prestige Paris",
      "Soirée Entreprise Haut de Gamme",
      "Anniversaire Signature Luxe",
      "Demande en Mariage Sur-Mesure Paris",
      "Privatisation Exclusive Évènement",
      "Coordination Évènementielle Prestige"
    ],
    "knowsAbout": [
      "agence évènementielle luxe paris",
      "wedding planner luxe paris",
      "organisation séminaire prestige paris",
      "soirée entreprise haut de gamme",
      "évènementiel créateur digital",
      "privatisation exclusive paris",
      "direction artistique évènement",
      "scénographie mariage prestige",
      "organisateur anniversaire prestige ile-de-france",
      "demande en mariage sur mesure paris",
      "haute couture évènementielle",
      "coordination évènementielle luxe Île-de-France"
    ],
    "sameAs": PROFILS_ENTREPRISE
  };

  const navigationStructuredData = [
    {
      "@context": "https://schema.org",
      "@type": "SiteNavigationElement",
      "name": "Demander un devis",
      "url": "https://maisoneridia.fr/devis",
      "description": "Obtenez votre devis personnalisé pour l'organisation de votre évènement privé"
    },
    {
      "@context": "https://schema.org",
      "@type": "SiteNavigationElement", 
      "name": "Nos évènements",
      "url": "https://maisoneridia.fr/evenements",
      "description": "Découvrez nos prestations d'organisation d'évènements"
    },
    {
      "@context": "https://schema.org",
      "@type": "SiteNavigationElement",
      "name": "Contact",
      "url": "https://maisoneridia.fr/contact",
      "description": "Contactez-nous pour organiser votre évènement"
    },
    {
      "@context": "https://schema.org",
      "@type": "SiteNavigationElement",
      "name": "À propos",
      "url": "https://maisoneridia.fr/a-propos", 
      "description": "Découvrez Maison Eridia et notre approche"
    }
  ];

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(websiteStructuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationStructuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(navigationStructuredData)}
      </script>
    </Helmet>
  );
};
